import React from "react";
import { motion } from "framer-motion";
import { Instagram, Mail } from "lucide-react";

function TikTokIcon({ size = 24 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M16.6 5.82A4.28 4.28 0 0 1 15.54 3h-3.09v12.4a2.59 2.59 0 1 1-2.59-2.59c.27 0 .53.04.77.12V9.79a5.7 5.7 0 0 0-.77-.05A5.68 5.68 0 1 0 15.54 15.4V9.01a7.35 7.35 0 0 0 4.3 1.38V7.3a4.28 4.28 0 0 1-3.24-1.48z" />
    </svg>
  );
}

export default function Social({ config }) {
  const email = config?.contact_email || "info@katemercerbooks.com";
  const socials = [
    {
      name: "Instagram",
      handle: config?.instagram_handle || "@katemercerbooks",
      url: config?.instagram_url || "#",
      Icon: Instagram,
      bg: "from-[#feda75] via-[#d62976] to-[#4f5bd5]",
      testid: "social-instagram",
      external: true,
    },
    {
      name: "TikTok",
      handle: config?.tiktok_handle || "@katemercerbooks",
      url: config?.tiktok_url || "#",
      Icon: TikTokIcon,
      bg: "from-[#25F4EE] via-[#000000] to-[#FE2C55]",
      testid: "social-tiktok",
      external: true,
    },
    {
      name: "Email",
      handle: email,
      url: `mailto:${email}`,
      Icon: Mail,
      bg: "from-[#D4AF37] to-[#B5952F]",
      testid: "social-email",
      external: false,
    },
  ];

  return (
    <section id="follow" className="py-28 sm:py-36 bg-[#F9FAFB]">
      <div className="max-w-5xl mx-auto px-6 sm:px-8 text-center">
        <span className="text-[11px] uppercase tracking-[0.3em] text-gold font-semibold">Stay Connected</span>
        <h2 className="font-display text-4xl sm:text-5xl font-bold tracking-tight mt-4 mb-12">Follow Kate Mercer</h2>
        <div className="grid sm:grid-cols-3 gap-6">
          {socials.map((s, i) => {
            const Icon = s.Icon;
            return (
              <motion.a
                key={s.name}
                href={s.url}
                target={s.external ? "_blank" : undefined}
                rel={s.external ? "noopener noreferrer" : undefined}
                data-testid={s.testid}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.1 }}
                className="group relative overflow-hidden rounded-3xl bg-white border border-gray-100 p-8 flex flex-col items-center text-center gap-4 gold-glow"
              >
                <span className={`h-16 w-16 rounded-2xl grid place-items-center text-white bg-gradient-to-br ${s.bg} group-hover:scale-110 transition-transform duration-500`}>
                  <Icon size={28} />
                </span>
                <div>
                  <p className="font-display text-xl font-bold">{s.name}</p>
                  <p className="text-sm text-gray-500 break-all">{s.handle}</p>
                </div>
                <span className="btn-ink rounded-full px-5 py-2.5 text-sm font-semibold">
                  {s.name === "Email" ? "Email Kate" : "Follow"}
                </span>
              </motion.a>
            );
          })}
        </div>
      </div>
    </section>
  );
}
